import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ChevronDoubleRightIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <polygon points="10.55 17.6 9.65 16.8 15.69 10.01 9.46 3.21 10.34 2.4 17.31 9.99 10.55 17.6" />
            <polygon points="3.65 17.61 2.75 16.81 8.79 10.02 2.56 3.22 3.44 2.41 10.41 10.01 3.65 17.61" />
            <rect style={{ fill: "none" }} width="20" height="20" transform="translate(20 20) rotate(-180)" />
        </SvgIcon>
    );
};
